import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Marketing from "@/pages/Marketing";
import DemoCommercial from "@/pages/DemoCommercial";
import DemoBoard from "@/pages/DemoBoard";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Marketing />} />
          <Route path="/demo/commercial" element={<DemoCommercial />} />
          <Route path="/demo/board" element={<DemoBoard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
